import { createReducer, on } from '@ngrx/store';
import { MatchingAnalyticsActions } from './matching-analytics.actions';
import { MatchingAnalyticsState, initialMatchingAnalyticsState } from './models/matching-analytics-state.models';

export const matchingAnalyticsReducer = createReducer(
  initialMatchingAnalyticsState,

  on(MatchingAnalyticsActions.loadOverview, (state): MatchingAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(MatchingAnalyticsActions.loadOverviewSuccess, (state, { overview }): MatchingAnalyticsState => ({
    ...state,
    overview,
    loading: false,
    error: null
  })),
  on(MatchingAnalyticsActions.loadOverviewFailure, (state, { error }): MatchingAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(MatchingAnalyticsActions.clearMatchingAnalyticsState, (): MatchingAnalyticsState => ({
    ...initialMatchingAnalyticsState
  }))
);
